"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _constant = require("./constant");

var _Avatar = _interopRequireDefault(require("./Avatar.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var getRenderSize = function getRenderSize(_ref) {
  var _renderSizes;

  var size = _ref.size;
  var renderSizes = (_renderSizes = {}, (0, _defineProperty2.default)(_renderSizes, _constant.SIZES.MEDIUM, parseInt(_constant.SIZES_INT[_constant.SIZES.MEDIUM], 10)), (0, _defineProperty2.default)(_renderSizes, _constant.SIZES.LARGE, parseInt(_constant.SIZES_INT[_constant.SIZES.LARGE], 10)), _renderSizes);
  return renderSizes[size];
};

var getTextType = function getTextType(_ref2) {
  var _renderFontSizes;

  var size = _ref2.size;
  var renderFontSizes = (_renderFontSizes = {}, (0, _defineProperty2.default)(_renderFontSizes, _constant.SIZES.MEDIUM, 'small'), (0, _defineProperty2.default)(_renderFontSizes, _constant.SIZES.LARGE, 'sub'), _renderFontSizes);
  return renderFontSizes[size];
};

var StyledAvatarContainer = _styledComponents.default.div.withConfig({
  displayName: "Avatar__StyledAvatarContainer",
  componentId: "sc-m316vb-0"
})(["border:1px solid ", ";background:", ";box-sizing:border-box;width:", ";height:", ";border-radius:50%;display:flex;"], function (props) {
  return props.border ? props.theme.colors[props.border] : props.theme.colors.secondaryBlue;
}, function (_ref3) {
  var theme = _ref3.theme,
      backgroundcolor = _ref3.backgroundcolor;
  return backgroundcolor ? theme.colors[backgroundcolor] : theme.colors.default;
}, function (_ref4) {
  var size = _ref4.size,
      theme = _ref4.theme;
  return "".concat(getRenderSize({
    theme: theme,
    size: size
  }), "px");
}, function (_ref5) {
  var size = _ref5.size,
      theme = _ref5.theme;
  return "".concat(getRenderSize({
    theme: theme,
    size: size
  }), "px");
});

var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "Avatar__TextContainer",
  componentId: "sc-m316vb-1"
})(["margin:auto;"]);

var getInitials = function getInitials(_ref6) {
  var fullname = _ref6.fullname;
  var avatarletters = fullname.replace(/^(Miss|Mr|Mrs|Ms|Miss.|Mr.|Mrs.|Ms.)\b/gm, '');
  return avatarletters.match(/(\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('').toUpperCase();
};

var renderAvatarImgIcon = function renderAvatarImgIcon(theme, size, accessible, fullname, color) {
  return /*#__PURE__*/_react.default.createElement(TextContainer, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    theme: theme,
    display: "inlineFlex",
    color: color,
    hasToggle: false,
    type: getTextType({
      size: size
    })
  }, getInitials({
    fullname: fullname
  })));
};

var Avatar = function Avatar(props) {
  var accessible = props.accessible,
      theme = props.theme,
      size = props.size,
      color = props.color,
      border = props.border,
      backgroundcolor = props.backgroundcolor,
      fullname = props.fullname;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledAvatarContainer, {
      tabIndex: tabIndex,
      size: size,
      theme: themeContext,
      fullname: fullname,
      color: color,
      backgroundcolor: backgroundcolor,
      border: border
    }, renderAvatarImgIcon(theme, size, accessible, fullname, color, backgroundcolor));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Avatar.propTypes = _Avatar.default.PropTypes;
Avatar.defaultProps = _Avatar.default.DefaultProps;
var _default = Avatar;
exports.default = _default;